module.exports = "https://images.shiksha.ws/saassets/media/LeftArrow.cccec967.png";